import { Link } from "react-router-dom";

const styles = {
  primary: "bg-brand-orange text-white hover:bg-[#c4631d]",
  secondary: "border border-slate-300 bg-white text-brand-ink hover:bg-slate-50",
  light: "bg-white text-brand-ink hover:bg-slate-100",
};

export function Button({ to, variant = "primary", className = "", children, ...props }) {
  const classes = `inline-flex items-center justify-center gap-2 rounded px-5 py-3 text-base font-semibold transition-colors duration-200 ${styles[variant]} ${className}`;
  if (to) return <Link to={to} className={classes}>{children}</Link>;
  return <button type="button" className={classes} {...props}>{children}</button>;
}
